import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModifierPipe } from './pipes/modifier.pipe';
import { PriceFromSizesPipe } from './pipes/price-from-sizes.pipe';
import { RadioSelectComponent } from './components/radio-select/radio-select.component';
import { MultipleSelectComponent } from './components/multiple-select/multiple-select.component';
import { CartProductNamePipe } from './pipes/cart-product-name.pipe';
import { ProductCountCartPipe } from './pipes/product-count-cart.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { CategoryHasProductPipe } from './pipes/category-has-product.pipe';
import { ProductToSalePipe } from './pipes/product-to-sale.pipe';
import { ProductModifierGroupComponent } from './components/product-modifier-group/product-modifier-group.component';
import { CheckboxSelectComponent } from './components/checkbox-select/checkbox-select.component';
import { SerializeAddressPipe } from './pipes/serialize-address.pipe';
import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { TouchOutsideDirective } from './directives/touch-outside.directive';
import { OrderEndingPipe } from './pipes/order-ending.pipe';
import { ModifiersListComponent } from './components/modifiers-list/modifiers-list.component';
import { HeaderComponent } from './components/header/header.component';
import { OnlyDigitsDirective } from './directives/only-digits.directive';
import { ClickStopPropagationDirective } from './directives/stopPropagation.directive';
import { SearchProductPipe } from './pipes/search.pipe';
import { RouterModule } from '@angular/router';
import { AddressPipe } from './pipes/address.pipe';
import { SuggestDirective } from './directives/suggest.directive';
import { CartProductPricePipe } from './pipes/cart-product-price.pipe';
import { ShowCurrencyPipe } from './pipes/show-currency.pipe';
import { HtmlEntityComponent } from './components/html-entity/html-entity.component';
import {
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
  NgxMatTimepickerModule
} from '@angular-material-components/datetime-picker';
import { MatDatepickerModule } from '@angular/material/datepicker';

const componentList = [
  RadioSelectComponent,
  MultipleSelectComponent,
  ProductModifierGroupComponent,
  CheckboxSelectComponent,
  HeaderComponent,
  HtmlEntityComponent
];

const pipeList = [
  ModifierPipe,
  PriceFromSizesPipe,
  CartProductNamePipe,
  AddressPipe,
  ProductCountCartPipe,
  CategoryHasProductPipe,
  ProductToSalePipe,
  SerializeAddressPipe,
  PhoneNumberPipe,
  OrderEndingPipe,
  SearchProductPipe,
  CartProductPricePipe,
];

const directiveList = [
  TouchOutsideDirective,
  OnlyDigitsDirective,
  ClickStopPropagationDirective
];

@NgModule({
  declarations: [...componentList, ...pipeList, ...directiveList, ModifiersListComponent, SuggestDirective, ShowCurrencyPipe],
  imports: [
    RouterModule,
    CommonModule,
    MatRadioModule,
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    FormsModule,
    MatChipsModule,

    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    MatDatepickerModule,

    // https://github.com/ngx-translate/core/issues/1193
    // - Use the TranslateModule's method forRoot() with config param isolate: false in AppModule to allow child,
    // lazy loaded modules to extend the parent or root module's loaded translations.
    // - Use the TranslateModule's method forChild() with config param extend: true in LazyLoadedModule to extend the
    // parent or root module's loaded translations.
    // - DO NOT attempt to move the TranslateModule setup and configuration from AppModule to a CoreModule as it won't
    // allow the root translations and only works when setup directly in AppModule.
    // - Force TranslateModule to load the LazyLoadedModule's child translations by setting the locale on
    // the TranslateService in its constructor.
    TranslateModule.forChild({
      extend: true
    }),
    ReactiveFormsModule,
  ],
  exports: [
    ...componentList,
    ...pipeList,
    ...directiveList,
    ModifiersListComponent,
    TranslateModule,
    SuggestDirective
  ]
})
export class SharedModule {
}
